import React, { useRef, useState }  from 'react';

import fastbuds from '../img/banner/fastbuds.png';
import gronn from '../img/banner/gronn.png';
import gorilla from '../img/banner/gorilla.png';
import vetrina_amazon from '../img/banner/vetrina_amazon.png';
import codici_sconto from '../img/banner/codici_sconto.png';
import playlist from '../img/banner/playlist.png';
import gruppo_telegram from '../img/banner/gruppo_telegram.png';
import Item from "./Item";
import Carousel from 'react-elastic-carousel';
import { FaPlayCircle, FaPauseCircle } from 'react-icons/fa'; 

export default function Carosello() {
    let autoPlaySpeed = 3000;
    let resetTimeout;
    const [autoplay, setAutoplay] = useState(true)
    const carouselRef = useRef(null);
    const items = 3;
    const breakPoints = [
        { width: 1, itemsToShow: 1, pagination: false },
        { width: 550, itemsToShow: 2, itemsToScroll: 1, pagination: false },
        { width: 768, itemsToShow: 3, itemsToScroll: 1, pagination: false },
        { width: 1200, itemsToShow: 3, itemsToScroll: 1, pagination: false }
    ];

    const totalPages = () => {
        let width = window.innerWidth
        let totalPages = 0

        if (width < 550)
            totalPages = items-1 
        else if (width < 945)
            totalPages = items-2
        else if (width < 1200)
            totalPages = items-3
        else if (width >= 1200)
            totalPages = items-3

        return totalPages
    }

    return (
        <>
        <Carousel 
            ref={carouselRef}
            breakPoints={breakPoints} 
            enableAutoPlay={autoplay} 
            autoPlaySpeed={autoPlaySpeed} 
            onNextEnd={({ index }) => {
                clearTimeout(resetTimeout)
                if (index === totalPages())
                    resetTimeout = setTimeout(() => {
                        try {carouselRef.current.goTo(0)} catch {}
                    }, autoPlaySpeed) // same time
            }}
        >         
        
        <Item>
                <div style={{ height: "100%", width: "100%",  display: "flex", flexFlow: "column"}}>
                    <a class="carousel--item" href="https://profilo.bio/filosofinerba" target="_blank">
                        <img src={codici_sconto} alt="Tutti i nostri Codici Sconto" title="Tutti i nostri Codici Sconto" width="100%" height="100%" />
                    </a>
                    <a class="carousel--item"  href="https://open.spotify.com/playlist/3YSpxUKhjwc0l13Yt1j3sS?si=594ff775f1584502" target="_blank">
                        <img src={playlist} alt="La nostra playlist UFFICIALE!" title="La nostra playlist UFFICIALE!" width="100%" height="100%" />
                    </a>
                    <a class="carousel--item carousel--item--united" href="https://www.instagram.com/freedomizi" target="_blank" >
                        👉🏻Curata da @freedomizi❤️👈🏻
                    </a>
                </div>
            </Item> 
        
            <Item>
                <div style={{ height: "100%", width: "100%",  display: "flex", flexFlow: "column"}}>
                    <a class="col carousel--item" style={{cursor: "pointer"}} onClick={() =>  window.open("https://myfastbuds.com/autoflowering-cannabis-seeds/?a_aid=5e0e82947091d", "_blank")}>
                        SEMI FastBuds🌱  codice sconto: FILOSOF15
                    </a> 
                    <div class="carousel--item carousel--item--united">
                        <a href="https://myfastbuds.com/autoflowering-cannabis-seeds?a_aid=5e0e82947091d" target="_blank">
                            <img src={fastbuds} alt="Buy Auto Seeds from Fast Buds" title="Buy Auto Seeds from Fast Buds" width="100%" height="100%" />
                        </a>
                    </div>
                </div>
            </Item> 
            <Item>
                <div style={{ height: "100%", width: "100%",  display: "flex", flexFlow: "column"}}>
                    <a class="carousel--item" style={{cursor: "pointer"}} href='https://www.greentastecbd.it/categoria-prodotto/cannabis-light/' target="_blank" >
                        <text>GreenTaste🍁  codice sconto: FILOSOFI420 </text>
                    </a>
                    <a class="carousel--item carousel--item--united"  href="https://www.greentastecbd.it/prodotto/filosofi-in-erba-gorilla/" target="_blank">
                        <img src={gorilla} alt="Erba selezionata da NOI!!! Gorilla" title="Erba selezionata da NOI!!! Gorilla" width="100%" height="100%" />
                    </a>
                    <a class="carousel--item "  href="https://t.me/GrowersinErba" target="_blank">
                        <img src={gruppo_telegram} alt="Gruppo growing Telegram!" title="Gruppo growing Telegram!" width="100%" height="100%" />
                    </a>
                </div>
            </Item>
            {false ? 
                    <>
                <Item>
                    <div style={{ height: "100%", width: "100%",  display: "flex", flexFlow: "column"}}>
                        <a class="carousel--item" href="https://profilo.bio/filosofinerba" target="_blank">
                            <text>Codici sconto!</text>
                        </a>
                        <a class="carousel--item" href="https://myfastbuds.com/?a_aid=5e0e82947091d" target="_blank">
                            <text>FastBuds🌱</text>
                            <br/>
                            <text>[15% codice "FILOSOF15"]</text>
                        </a>
                        <a class="carousel--item" href="https://www.greentastecbd.it/categoria-prodotto/cannabis-light/">
                            <text>GreenTaste🍁🍫</text>
                            <br/>
                            <text>[20% codice "FILOSOFI420"]</text>
                        </a>
                        <a class="carousel--item" href="https://www.onebloodgenetics.com/grow-shop">
                            <text>OneBlood Genetics Growshop💡</text>
                            <br/>
                            <text>[15% codice "FILOSOFI15"]</text>
                        </a>
                    </div>
                </Item>
                    <Item>
                        <div style={{ height: "100%", width: "100%",  display: "flex", flexFlow: "column"}}>
                            <div class="col carousel--item">
                                <text>GRONN 💨🚫  #smokesmasher</text>
                            </div>
                            <div class="carousel--item carousel--item--united" >
                                <a href="https://www.gronn.it" target="_blank">
                                    <img src={gronn} alt=" Gronn.it SmokeSmasher!!!" title=" Gronn.it SmokeSmasher!!!" width="100%" height="100%" />
                                </a>
                            </div>
                            <div class="col carousel--item carousel--item--united">
                                <text>Fumi in auto o in casa? Questo prodotto elimina l'odore di FUMO!</text>
                            </div>
                            <a class="carousel--item" href="https://www.youtube.com/watch?v=eimjUNkyfFw" target="_blank" >
                                <text >
                                    👉🏻Guarda la recensione👈🏻
                                </text>
                            </a>
                            
                        </div>
                    </Item>
                        <Item>
                        <div style={{ height: "100%", width: "100%",  display: "flex", flexFlow: "column"}}>
                            <div class="col carousel--item">
                                <text>
                                    👇🏼 Visita la nostra vetrina Amazon! 👇🏼
                                </text>
                            </div> 
                            <a class="carousel--item carousel--item--united"  href="https://www.amazon.it/shop/filosofi_in_erba" target="_blank">
                                <img src={vetrina_amazon} alt="La nostra vetrina Amazon!" title="La nostra vetrina Amazon!" width="100%" height="100%" />
                            </a>
                        </div>
                    </Item>  
                    </>
                    :null
                }
        </Carousel>
        <text className="accedi">
            AutoScroll: 
            {autoplay ? 
                <FaPauseCircle onClick={() => setAutoplay(!autoplay)} style={{marginLeft: "0.5%", cursor: 'pointer', filter: "drop-shadow(0px 0px 1px #1c242b)"}}/>:
                <FaPlayCircle onClick={() => setAutoplay(!autoplay)} style={{marginLeft: "0.5%", cursor: 'pointer', filter: "drop-shadow(0px 0px 1px #1c242b)"}}/>
            }
        </text>
        <br/>
        
        </>

    );
}